import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  getFileTags,
  GetFileTagsResponse,
} from '@/services/data-sources/get-file-tags';

interface UseGetFileTagsOptions extends Omit<
  UseQueryOptions<GetFileTagsResponse>,
  'queryKey' | 'queryFn'
> {
  collectionId?: string;
  filename?: string;
  orgId?: string;
}

export const useGetFileTags = (options?: UseGetFileTagsOptions) => {
  const { collectionId, filename, orgId, ...queryOptions } = options || {};

  return useQuery<GetFileTagsResponse>({
    queryKey: ['file-tags', orgId, collectionId, filename],
    queryFn: async () => {
      if (!collectionId || !filename) {
        throw new Error('collectionId and filename are required');
      }
      return getFileTags({ collectionId, filename });
    },
    enabled: !!collectionId && !!filename && !!orgId,
    staleTime: 10 * 1000,
    ...queryOptions,
  });
};
